export const tokenKey = `paces-token-${process.env.STAGE}`;
export const refreshTokenKey = `paces-refresh-token-${process.env.STAGE}`;
export const accessTokenKey = `paces-access-token-${process.env.STAGE}`;
